var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfluencerAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_181_272)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 91,
    height: 91,
    rx: 45.5,
    fill: "#616161",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6668 37.9167C66.6668 43 64.6475 47.8751 61.053 51.4696C57.4586 55.064 52.5835 57.0833 47.5002 57.0833C42.4168 57.0833 37.5417 55.064 33.9473 51.4696C30.3528 47.8751 28.3335 43 28.3335 37.9167C28.3335 32.8334 30.3528 27.9582 33.9473 24.3638C37.5417 20.7693 42.4168 18.75 47.5002 18.75C52.5835 18.75 57.4586 20.7693 61.053 24.3638C64.6475 27.9582 66.6668 32.8334 66.6668 37.9167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.0824 94.9618C21.0149 93.956 1 73.3136 1 47.9994C1 22.0413 22.0419 0.999359 48 0.999359C73.9581 0.999359 95 22.0413 95 47.9994C95 73.9575 73.9581 94.9994 48 94.9994H47.3561C46.93 94.9994 46.5054 94.9868 46.0824 94.9618ZM17.8401 77.6564C17.4887 76.6472 17.3691 75.5719 17.4901 74.5101C17.6112 73.4484 17.9698 72.4276 18.5394 71.5235C19.109 70.6193 19.8749 69.8551 20.7802 69.2875C21.6856 68.7198 22.7072 68.3634 23.7691 68.2446C42.0897 66.2166 54.023 66.3999 72.2543 68.2869C73.3177 68.3976 74.3418 68.7496 75.2486 69.3159C76.1555 69.8823 76.9211 70.6481 77.4872 71.5551C78.0533 72.462 78.405 73.4862 78.5155 74.5496C78.6259 75.6131 78.4923 76.6876 78.1246 77.6916C85.9387 69.7862 90.3145 59.1148 90.3 47.9994C90.3 24.638 71.3613 5.69936 48 5.69936C24.6386 5.69936 5.7 24.638 5.7 47.9994C5.7 59.552 10.3319 70.0236 17.8401 77.6564Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_181_272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95.83,
    height: 95.83,
    rx: 47.915,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfluencerAvatar);
export default __webpack_public_path__ + "static/media/influencer-avatar.1110f3ab600eaf78f10b46e7a4f5302e.svg";
export { ForwardRef as ReactComponent };